import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Avatar, AvatarGroup, Box, Typography } from '@mui/material';

import { Reservation } from '../../../graphql/API';
import Button from '../../Button/Button';
import BaseDialog, { BaseDialogProps } from '../Base';

type Props = { reservations?: Reservation[] } & BaseDialogProps;

export const ShipmentReminderDialog: React.FC<Props> = ({ reservations, ...rest }) => {
  const navigate = useNavigate();
  const users = reservations?.map((reservation) => reservation.user);
  const usersPicture = reservations?.map((reservation) => reservation.userPicture);

  const handleNavigation = () => {
    rest?.onClose?.({}, 'backdropClick');
    navigate('/chats');
  };

  const handleReservationsNavigation = () => {
    rest?.onClose?.({}, 'backdropClick');
    navigate('/reservations');
  };

  return (
    <BaseDialog width='400px' height={'380pxpx'} minHeight='380pxpx' minWidth='400px' {...rest}>
      <Box
        display={'flex'}
        flexDirection={'column'}
        justifyContent={'space-between'}
        px={1.6}
        py={2}
        gap={5}
      >
        <Box>
          <Box display={'flex'} alignItems={'center'} justifyContent={'center'}>
            <AvatarGroup spacing={34}>
              {usersPicture?.slice(0, 3).map((user) => (
                <Avatar
                  variant='rounded'
                  src={user?.small || 'https://i.pravatar.cc/300'}
                  alt={String(user?.thumbnail)}
                  sx={{
                    width: '70px',
                    height: '70px',
                    borderRadius: '50%',
                    objectFit: 'contain',
                  }}
                />
              ))}
            </AvatarGroup>
          </Box>
          <Box mt={5} display={'flex'} flexDirection={'column'} gap={'8px'}>
            <Typography
              fontFamily={'Poppins'}
              fontSize={'18px'}
              fontWeight={500}
              textAlign={'center'}
            >
              {users?.length === 1 ? (
                `${users[0]?.firstname} is waiting for you to ship`
              ) : (
                <>{users?.length} users are waiting for you to ship</>
              )}
            </Typography>
            {(users || [])?.length > 1 ? (
              <Typography fontFamily={'Poppins'} fontSize={'15px'} textAlign={'center'}>
                Chat with the users to get their shipping details. Once shipped, click{' '}
                <Typography component={'span'} fontSize={'15px'} fontWeight={500}>
                  Mark as Shipped
                </Typography>{' '}
                in the reservation details.
              </Typography>
            ) : (
              <Typography fontFamily={'Poppins'} fontSize={'15px'} textAlign={'center'}>
                Chat with {users && users[0]?.firstname} to get their shipping details. Once
                shipped, click{' '}
                <Typography component={'span'} fontSize={'15px'} fontWeight={500}>
                  Mark as Shipped
                </Typography>{' '}
                in the reservation details.
              </Typography>
            )}
          </Box>
        </Box>

        <Box display={'flex'} flexDirection={'column'} gap={2}>
          <Button
            variant='contained'
            color='primary'
            fullWidth
            sx={{ py: 1.5 }}
            onClick={handleReservationsNavigation}
          >
            Go to reservations
          </Button>
        </Box>
      </Box>
    </BaseDialog>
  );
};
